import React from 'react';
import { RewardsDashboardView } from './View';
import { getConsumerRewardOptInStatus } from '../../../../context/mockData/data';
export var RewardsDashboardContainer = function () {
    var _a;
    return (React.createElement(RewardsDashboardView, { consumerRewardOptInStatus: (_a = getConsumerRewardOptInStatus === null || getConsumerRewardOptInStatus === void 0 ? void 0 : getConsumerRewardOptInStatus.status) === null || _a === void 0 ? void 0 : _a.status, promotions: [], loading: false }));
};
